import { Diagnosis } from '../hypothesis'

export default [
  {
    /** @type {Diagnosis} */
    diagnosis(answers) {
      if (answers['41'] == 'sim') {
        return {
          text: 'Asma',
          proceed: true,
        }
      }

      if (['nao', 'nao-definido'].includes(answers['41'])) {
        return {
          text: 'Sem diagnóstico de asma',
          proceed: false,
        }
      }

      return {
        proceed: false,
      }
    },
    version: {
      /** @type {number[]} */
      include: [],
      /** @type {number[]} */
      exclude: [],
    },
  },
]
